import React from 'react';
import $ from 'jquery';

export const DataKeys = {
    MD: "masterdata",
    WD: "walldata",
    UD: "userdata",
    U: "user",
    AT: "authtoken",
    UI: "userinfo",
    GD: "gptdata",
    ES: "expandedstates",
    LANG: "language",
    LANGLABELS: "langlabels",
    LUD:"languagedata"     
}


const STORAGE_KEY = "pinnacleailang";

let initialLanguage = {
    Name: "English",
    Lang: "English",
    Code: "en"
};

try {
    const storedLang = localStorage.getItem(STORAGE_KEY);
    if (storedLang) {
        initialLanguage = JSON.parse(storedLang);
    }
} catch (e) {
    console.error("Invalid language JSON in localStorage", e);
}

var data = {
    MD: {},
    WD: [],
    User: null,
    UD: {},
    GD: {},
    AT: "",
    UI: [],
    ES: {},
    selectedLanguage: initialLanguage,
    LangLabels:[],
    LUD:{}
}
// function reducer(state = data, action) {
//     switch (action.type) {
//         //case "Car":
//         //    return {
//         //        vehicle: "It is a Car",
//         //        products: action.products
//         //    };
//         //case "Bike":
//         //    return {
//         //        vehicle: "It is a Bike",
//         //        products: action.products,

//         //    };
//         case DataKeys.MD:
//             return {
//                 U: state.U,
//                 UD: state.UD,
//                 GD: state.GD,
//                 WD: state.WD,
//                 AT: state.AT,
//                 MD: action.MD,
//                 UI: state.UI
//             }
//         case DataKeys.WD:
//             return {
//                 MD: state.MD,
//                 U: state.U,
//                 UD: state.UD,
//                 GD: state.GD,
//                 AT: state.AT,
//                 WD: state.WD
//             }
//         case DataKeys.UD:
           
//             return {
//                 MD: state.MD,
//                 U: state.U,
//                 WD: state.WD,
//                 AT: state.AT,
//                 UD: action.UD,
//                 GD: state.GD,
//                 UI: state.UI
//             }
//             case DataKeys.GD:
           
//             return {
//                 MD: state.MD,
//                 U: state.U,
//                 WD: state.WD,
//                 AT: state.AT,
//                 UD: state.UD,
//                 GD: action.GD,
//                 UI: state.UI
//             }
//         case DataKeys.U:

//             return {
//                 MD: state.MD,
//                 UD: state.UD,
//                 GD: state.GD,
//                 WD: state.WD,
//                 AT: state.AT,
//                 U: action.U,
//                 UI: state.UI
//             }
//         case DataKeys.AT:
//             return {
//                 MD: state.MD,
//                 U: state.U,
//                 UD: state.UD,
//                 GD: state.GD,
//                 WD: state.WD,
//                 AT: action.AT,
//                 UI: state.UI
//             }
//         case DataKeys.UI:
//             return {
//                 MD: state.MD,
//                 U: state.U,
//                 UD: state.UD,
//                 GD: state.GD,
//                 WD: state.WD,
//                 AT: state.AT,
//                 UI: action.UI
//             }
//         case DataKeys.ES:
//             return {
//                 ...state,
//                 ES: {
//                     ...(state.ES || {}),
//                     [action.title]: state.ES?.[action.title] === undefined ? true : !state.ES[action.title]
//                 }
//             };
//         case DataKeys.LANG:
//             return {
//                 ...state,
//                 selectedLanguage: action.language
//             };
//         case DataKeys.LANGLABELS:
//             return {
//                 ...state,
//                 LangLabels: action.langlabels
//             };
//         default:
//             return state;
//     }
// }

function reducer(state = data, action) {
    switch (action.type) {
        case DataKeys.UD:
            return { ...state, UD: action.UD };
        case DataKeys.MD:
            return { ...state, MD: action.MD };
        case DataKeys.WD:
            return { ...state, WD: state.WD };
        case DataKeys.GD:
            return { ...state, GD: action.GD };
        case DataKeys.U:
            return { ...state, U: action.U };
        case DataKeys.AT:
            return { ...state, AT: action.AT };
        case DataKeys.UI:
            return { ...state, UI: action.UI };
        case DataKeys.ES:
            return {
                ...state,
                ES: {
                    ...(state.ES || {}),
                    [action.title]: state.ES?.[action.title] === undefined ? false : !state.ES[action.title]
                }
            };
        case DataKeys.LANG:
            return { ...state, selectedLanguage: action.language };
        case DataKeys.LANGLABELS:
            return { ...state, LangLabels: action.langlabels };
        case DataKeys.LUD:
            return { ...state, LUD: action.LUD };
        default:
            return state;
    }
}


export default reducer;

// #region actions

export function StoreMasterData(MD) {
   
    return {
        type: DataKeys.MD,
        MD : MD
    }
}
export function StoreUserInfoData(UI) {

    return {
        type: DataKeys.UI,
        UI: UI
    }
}
export function StoreWallData(WD) {
    return {
        type: DataKeys.WD,
        WD: WD
    }
}

export function StoreUserData(UD) {
   
    return {
        type: DataKeys.UD,
        UD: UD
    }
}

export function StoreGPTData(GD) {
   
    return {
        type: DataKeys.GD,
        GD: GD
    }
}

export function StoreUser(U) {

    return {
        type: DataKeys.U,
        U : U
    }
}
export function StoreAuthToken(AT) {
   
    return {
        type: DataKeys.AT,
        AT: AT
    }
}

export function StoreExpandState(title) {
    return {
        type: DataKeys.ES,
        title: title
    }
}

export function StoreLanguage(language) {
    return {
        type: DataKeys.LANG,
        language
    };
}

export function StoreLanguageLabels(langlabels) {
    return {
        type: DataKeys.LANGLABELS,
        langlabels
    };
}
export function StoreLanguageData(LUD) {
    return {
        type: DataKeys.LUD,
        LUD
    };
}
// #endregion actions


